module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabrielsTrail_BW-p-800-bbfc392da94ed7a6f87f71306bbd98a3.jpg";